import React, { Component, useState, useEffect } from "react";
import "../../Page/Dashboard/index.css";
import "../index.css";
import "./index.css";
import TopMenu from "../Layout/TopMenu";
import MenuDesktop from "../Layout/MenuDesktop";
import { MDBRow, MDBCol } from "mdbreact";
import { NavLink, withRouter } from "react-router-dom";
import {
  RiArrowDownSLine,
  RiArrowUpSLine,
  RiArrowRightSLine,
  RiCloseLine,
} from "react-icons/ri";
import { BiChevronRight } from "react-icons/bi";
import { BsFillPlayFill } from "react-icons/bs";
import { FaMoneyBillAlt, FaYoutube } from "react-icons/fa";
import { RiSpeedFill } from "react-icons/ri";
import { BiPause } from "react-icons/bi";
import mixpanel from "mixpanel-browser";
import { HiLightningBolt, HiSortAscending } from "react-icons/hi";

import { firebase } from "../../../firebase/config";

import { TiTick } from "react-icons/ti";
import VisibilitySensor from "react-visibility-sensor";
import { IoSearch, IoLocationSharp, IoArrowUp } from "react-icons/io5";
import Scroll from "react-scroll";
import Footer from "../Layout/Footer";
import FAQ from "../FAQ";
import { VscStarEmpty } from "react-icons/vsc";
import {
  US,
  IN,
  PH,
  BR,
  UA,
  PK,
  AR,
  PL,
  MY,
  BD,
  CN,
  MX,
  CO,
  GB,
  ES,
  FR,
  DE,
  IT,
  PT,
} from "country-flag-icons/react/3x2";

const scroll = Scroll.animateScroll;

function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

let x1 = randomIntFromInterval(10, 200);

const Landing = () => {
  const [playing, setPlaying] = useState(false);
  const [audio, setAudio] = useState(null);
  const [sample, setSample] = useState(1);
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [url, setURL] = useState(
    "https://res.cloudinary.com/ditzmaeto/video/upload/v1688143830/English_sarula.mp4"
  );
  const playAudio = (num) => {
    if (audio) {
      audio.pause();
    }
    if (num === 1) {
      setPlaying(true);
      setAudio(new Audio(require("./Sample.mp3")));
    } else if (num === 2) {
      setPlaying(true);
      setAudio(new Audio(require("./Sample3.mp3")));
    } else {
      setPlaying(true);
      setAudio(new Audio(require("./Sample2.mp3")));
    }
  };

  const pauseAudio = () => {
    if (audio) {
      audio.pause();
    }
    setPlaying(false);
  };

  useEffect(() => {
    if (audio) {
      audio.play();
      audio.addEventListener("ended", () => {
        setPlaying(false);
      });
    }
  }, [audio]);

  useEffect(() => {
    if (audio && audio.paused) {
      setPlaying(false);
    }
  }, [audio]);
  return (
    <>
      <MDBCol
        className="backy26"
        style={{
          overflowX: "hidden",
          backgroundColor: "black",
          color: "white",
        }}
        size="12"
      >
        <MDBRow className="HeroSection" style={{ marginTop: 0 }}>
          <MenuDesktop color="dark" />
          <MDBRow
            className="d-flex justify-content-center"
            style={{
              marginTop: 0,
              overflowY: "hidden",
            }}
          >
            <MDBCol
              style={{
                color: "white",
                paddingBottom: 10,
              }}
              className="HeroSection d-flex justify-content-center"
            >
              <MDBRow
                style={{ width: "100vw" }}
                className="d-flex justify-content-center"
              >
                <MDBCol className="d-flex justify-content-center" size="12">
                  <div
                    style={{
                      height: 40,
                      width: 500,
                      marginTop: 80,
                      backgroundColor: "#fbfbfb",
                      borderRadius: 5,
                      color: "#5d6b98",
                      textAlign: "center",
                    }}
                  >
                    <p
                      style={{
                        marginTop: 10.5,
                        fontFamily: "PlusJSBold",
                        fontSize: 13.4,
                      }}
                    >
                      NEW - Introducing YouFast, our new model for fast
                      parallelized dubbing
                    </p>
                  </div>
                </MDBCol>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{ marginTop: 24, color: "#fcfcfc" }}
                    className="HeroHeading"
                  >
                    Automated dubbing for your
                    <br />
                    videos and podcasts
                    <br />
                  </p>
                </MDBCol>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p className="HeroSubHeading">
                    Grow your podcast or youtube channel audience instantly with
                    <br /> high quality fast dubbing. Try it free today.
                  </p>
                </MDBCol>
                <MDBCol className="HeroButtonPosition" size="12">
                  <a
                    href="https://app.youdub.me"
                    target="_blank"
                    className="d-flex justify-content-center HeroLink"
                  >
                    <div
                      style={{ borderRadius: 200 }}
                      className="d-flex justify-content-center HeroButton lightButton"
                    >
                      Try it out{" "}
                      <BiChevronRight
                        style={{
                          marginLeft: 5,
                          fontSize: 22,
                          marginBottom: -1,
                        }}
                      />
                    </div>
                  </a>
                  <a
                    className="HeroLink"
                    href="mailto:help@youdub.me"
                    target="_blank"
                    style={{
                      marginTop: 30,
                      marginLeft: 10,
                      fontFamily: "PlusJSBold",
                      opacity: 1,
                      color: "white",
                    }}
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    Contact sales{" "}
                    <BiChevronRight
                      style={{
                        marginLeft: 2,
                        fontSize: 22,
                        marginTop: -1.4,
                      }}
                    />
                  </a>
                </MDBCol>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <div
                    style={{
                      height: 452,
                      width: 900,
                      backgroundColor: "black",
                      marginTop: 50,
                      borderRadius: 9,
                      border: "1px solid black",
                    }}
                  >
                    <MDBRow>
                      <MDBCol size="4">
                        <MDBRow>
                          <MDBCol size="12">
                            <div
                              onClick={() => {
                                setURL(
                                  "https://res.cloudinary.com/ditzmaeto/video/upload/v1688143830/English_sarula.mp4"
                                );
                                setSelectedLanguage("English");
                              }}
                              style={{
                                height: 90,
                                width: "100%",
                                backgroundColor: "#505050",
                                borderTopLeftRadius: 9,
                                cursor: "pointer",
                                opacity:
                                  selectedLanguage === "English" ? 1 : 0.5,
                              }}
                              className="d-flex justify-content-center"
                            >
                              <p
                                style={{
                                  fontFamily: "PlusJSBold",
                                  marginTop: 25,
                                  fontSize: 27,
                                }}
                              >
                                <GB
                                  style={{
                                    height: 24,
                                    marginRight: 9,
                                    marginTop: -6,
                                  }}
                                  title="India"
                                />
                                English
                              </p>
                            </div>
                          </MDBCol>
                          <MDBCol size="12">
                            <div
                              onClick={() => {
                                setURL(
                                  "https://res.cloudinary.com/ditzmaeto/video/upload/v1688143840/Spanish_qomvtd.mp4"
                                );
                                setSelectedLanguage("Spanish");
                              }}
                              style={{
                                height: 90,
                                width: "100%",
                                backgroundColor: "#505050",
                                cursor: "pointer",
                                opacity:
                                  selectedLanguage === "Spanish" ? 1 : 0.5,
                              }}
                              className="d-flex justify-content-center"
                            >
                              <p
                                style={{
                                  fontFamily: "PlusJSBold",
                                  marginTop: 25,
                                  fontSize: 27,
                                }}
                              >
                                <ES
                                  style={{
                                    height: 24,
                                    marginRight: 9,
                                    marginTop: -6,
                                  }}
                                  title="India"
                                />
                                Spanish
                              </p>
                            </div>
                          </MDBCol>
                          <MDBCol size="12">
                            <div
                              onClick={() => {
                                setURL(
                                  "https://res.cloudinary.com/ditzmaeto/video/upload/v1688147216/Hindi_icqg3f.mp4"
                                );
                                setSelectedLanguage("Hindi");
                              }}
                              style={{
                                height: 90,
                                width: "100%",
                                backgroundColor: "#505050",
                                cursor: "pointer",
                                opacity: selectedLanguage === "Hindi" ? 1 : 0.5,
                              }}
                              className="d-flex justify-content-center"
                            >
                              <p
                                style={{
                                  fontFamily: "PlusJSBold",
                                  marginTop: 25,
                                  fontSize: 27,
                                }}
                              >
                                <IN
                                  style={{
                                    height: 24,
                                    marginRight: 9,
                                    marginTop: -6,
                                  }}
                                  title="India"
                                />
                                Hindi
                              </p>
                            </div>
                          </MDBCol>
                          <MDBCol size="12">
                            <div
                              onClick={() => {
                                setURL(
                                  "https://res.cloudinary.com/ditzmaeto/video/upload/v1688152404/French_ftgjpk.mp4"
                                );
                                setSelectedLanguage("French");
                              }}
                              style={{
                                height: 90,
                                width: "100%",
                                backgroundColor: "#505050",
                                opacity:
                                  selectedLanguage === "French" ? 1 : 0.5,
                                cursor: "pointer",
                              }}
                              className="d-flex justify-content-center"
                            >
                              <p
                                style={{
                                  fontFamily: "PlusJSBold",
                                  marginTop: 25,
                                  fontSize: 27,
                                }}
                              >
                                <FR
                                  style={{
                                    height: 24,
                                    marginRight: 9,
                                    marginTop: -6,
                                  }}
                                  title="India"
                                />
                                French
                              </p>
                            </div>
                          </MDBCol>
                          <MDBCol size="12">
                            <div
                              onClick={() => {
                                setURL(
                                  "https://res.cloudinary.com/ditzmaeto/video/upload/v1688152397/German_du6swe.mp4"
                                );
                                setSelectedLanguage("German");
                              }}
                              style={{
                                height: 90,
                                width: "100%",
                                borderBottomLeftRadius: 9,
                                backgroundColor: "#505050",
                                opacity: 0.5,
                                cursor: "pointer",
                                opacity:
                                  selectedLanguage === "German" ? 1 : 0.5,
                              }}
                              className="d-flex justify-content-center"
                            >
                              <p
                                style={{
                                  fontFamily: "PlusJSBold",
                                  marginTop: 25,
                                  fontSize: 27,
                                }}
                              >
                                <DE
                                  style={{
                                    height: 24,
                                    marginRight: 9,
                                    marginTop: -6,
                                  }}
                                  title="India"
                                />
                                German
                              </p>
                            </div>
                          </MDBCol>
                        </MDBRow>
                      </MDBCol>
                      <MDBCol size="8">
                        <video
                          src={url}
                          controls
                          style={{
                            marginLeft: -30,
                            width: 620,
                            borderTopRightRadius: 9,
                            borderBottomRightRadius: 9,
                            height: 450,
                            objectFit: "cover",
                          }}
                        />
                      </MDBCol>
                    </MDBRow>
                  </div>
                </MDBCol>
              </MDBRow>
            </MDBCol>
          </MDBRow>
        </MDBRow>

        <MDBRow
          style={{
            marginTop: 0,
            overflowY: "hidden",
            overflowX: "hidden",
            paddingTop: 60,
            paddingBottom: 50,
            color: "white",
          }}
          className="HeroSection"
        >
          <MDBCol className="d-flex justify-content-center" size="12">
            <p
              style={{
                fontFamily: "PlusJSBold",
                fontSize: 30,
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              Why should I use{" "}
              <p style={{ fontFamily: "Grifter", display: "inline-block" }}>
                YouDub?
              </p>
            </p>
          </MDBCol>
          <MDBCol className="d-flex justify-content-center" size="12">
            <MDBRow style={{ width: "60vw" }}>
              <MDBCol className="d-flex justify-content-center" size="4">
                <MDBRow>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    <FaMoneyBillAlt style={{ color: "white", fontSize: 30 }} />
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    {" "}
                    <p
                      style={{
                        textAlign: "center",
                        fontFamily: "PlusJSSemiBold",
                        marginTop: 23,
                      }}
                    >
                      Save money
                    </p>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    {" "}
                    <p
                      style={{
                        textAlign: "center",
                        fontFamily: "PlusJSMedium",
                        marginTop: -10,
                        opacity: 0.7,
                        fontSize: 14,
                      }}
                    >
                      We offer the best prices per min of dubbing. We are
                      typically 50% cheaper than competition.
                    </p>
                  </MDBCol>
                </MDBRow>
              </MDBCol>
              <MDBCol className="d-flex justify-content-center" size="4">
                <MDBRow>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    <RiSpeedFill style={{ color: "white", fontSize: 30 }} />
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    {" "}
                    <p
                      style={{
                        textAlign: "center",
                        fontFamily: "PlusJSSemiBold",
                        marginTop: 24,
                      }}
                    >
                      Fastest generator on market
                    </p>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    {" "}
                    <p
                      style={{
                        textAlign: "center",
                        fontFamily: "PlusJSMedium",
                        marginTop: -9,
                        opacity: 0.7,
                        fontSize: 14,
                      }}
                    >
                      Our dubbing engine can run unlimited number of tasks in
                      parallel. We are 40% faster than competition.
                    </p>
                  </MDBCol>
                </MDBRow>
              </MDBCol>
              <MDBCol className="d-flex justify-content-center" size="4">
                <MDBRow>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    <FaYoutube style={{ color: "white", fontSize: 30 }} />
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    {" "}
                    <p
                      style={{
                        textAlign: "center",
                        fontFamily: "PlusJSSemiBold",
                        marginTop: 24,
                      }}
                    >
                      Built for scale
                    </p>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    {" "}
                    <p
                      style={{
                        textAlign: "center",
                        fontFamily: "PlusJSMedium",
                        marginTop: -9,
                        opacity: 0.7,
                        fontSize: 14,
                      }}
                    >
                      We've built YouDub with one audience in mind, Youtube
                      Channels that want to scale to new audiences cheaply.
                    </p>
                  </MDBCol>
                </MDBRow>
              </MDBCol>
            </MDBRow>
          </MDBCol>

          <MDBCol
            style={{
              marginTop: 120,
              color: "white",
            }}
            size="12"
            className=" d-flex justify-content-center HeroSection"
          >
            <MDBRow style={{ marginTop: 0 }}>
              <MDBCol className="d-flex justify-content-center" size="12">
                <p
                  style={{
                    fontFamily: "PlusJSBold",
                    fontSize: 30,
                    fontWeight: "600",
                    textAlign: "center",
                    color: "white",
                  }}
                >
                  Works with many languages
                </p>
              </MDBCol>
              <MDBCol
                className="d-flex justify-content-center"
                style={{ marginTop: -10 }}
                size="12"
              >
                <p
                  style={{
                    fontFamily: "PlusJSMedium",
                    fontSize: 17,
                    textAlign: "center",
                    marginTop: 0,
                    width: "90%",
                    opacity: 0.9,
                  }}
                >
                  YouDub is able to dub into 8 different languages covering 96%
                  of the world's population.
                </p>
              </MDBCol>
              <MDBCol
                size="12"
                style={{
                  width: "90%",
                  height: 280,
                  marginTop: 10,
                }}
                className="d-flex justify-content-center"
              >
                <MDBRow
                  style={{
                    height: "45%",
                    width: 850,
                    color: "black",
                  }}
                >
                  <MDBCol className="d-flex justify-content-center" size="3">
                    <div
                      style={{
                        height: 50,
                        width: 200,
                        marginRight: -20,
                        backgroundColor: "white",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        <IN
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="India"
                        />
                        Hindi
                      </p>
                    </div>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="3">
                    <div
                      style={{
                        height: 50,
                        width: 200,

                        backgroundColor: "white",
                      }}
                    >
                      {" "}
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                        }}
                      >
                        <ES
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="Phillipines"
                        />
                        Spanish
                      </p>
                    </div>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="3">
                    <div
                      style={{
                        height: 50,
                        width: 200,
                        marginLeft: -20,
                        backgroundColor: "white",
                      }}
                    >
                      {" "}
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                        }}
                      >
                        <DE
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="Brazil"
                        />
                        German
                      </p>
                    </div>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="3">
                    <div
                      style={{
                        height: 50,
                        width: 200,
                        marginLeft: -20,
                        backgroundColor: "white",
                      }}
                    >
                      {" "}
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                        }}
                      >
                        <GB
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="Ukraine"
                        />
                        English
                      </p>
                    </div>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="3">
                    <div
                      style={{
                        height: 50,
                        width: 200,
                        marginRight: -20,
                        backgroundColor: "white",
                      }}
                    >
                      {" "}
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                        }}
                      >
                        <FR
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="Pakistan"
                        />
                        French
                      </p>
                    </div>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="3">
                    <div
                      style={{
                        height: 50,
                        width: 200,

                        backgroundColor: "white",
                      }}
                    >
                      {" "}
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                        }}
                      >
                        <IT
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="Argentina"
                        />
                        Italian
                      </p>
                    </div>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="3">
                    <div
                      style={{
                        height: 50,
                        width: 200,
                        marginLeft: -20,
                        backgroundColor: "white",
                      }}
                    >
                      {" "}
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                        }}
                      >
                        <PL
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="Poland"
                        />
                        Polish
                      </p>
                    </div>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="3">
                    <div
                      style={{
                        height: 50,
                        width: 200,
                        marginLeft: -20,
                        backgroundColor: "white",
                      }}
                    >
                      {" "}
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                        }}
                      >
                        <PT
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="Malaysia"
                        />
                        Portuguese
                      </p>
                    </div>
                  </MDBCol>
                </MDBRow>
              </MDBCol>
            </MDBRow>
          </MDBCol>

          <FAQ />

          <MDBCol className="d-flex justify-content-center" size="12">
            <hr
              style={{
                width: "84%",
                color: "white",
                height: 1,
                marginTop: 70,
              }}
            />
          </MDBCol>
          <MDBCol style={{ paddingLeft: "12%" }} size="6">
            <p
              style={{
                fontFamily: "PlusJSExtraBold",
                marginTop: 60,
                fontSize: 33,
                lineHeight: 1.2,
                fontWeight: "600",
              }}
            >
              Learn more about YouDub
            </p>
            <a href="" target="_blank" onClick={() => window.scrollTo(0, 0)}>
              <div
                className="d-flex HeroButton lightButton justify-content-center"
                style={{
                  paddingTop: 14,
                  marginLeft: -4,
                  fontSize: 15,
                  width: 170,
                  height: 49,
                  marginTop: 40,
                  display: "inline-block",
                }}
              >
                Book a Demo
              </div>
            </a>
          </MDBCol>
          <MDBCol style={{ paddingLeft: "7%" }} size="6">
            <img
              src={require("./fingers.png")}
              style={{ height: 240, width: "auto", marginTop: 50 }}
            />
          </MDBCol>
        </MDBRow>
      </MDBCol>
      <div className="HeroSection">
        <Footer />
      </div>
    </>
  );
};

export default withRouter(Landing);
